import { gql } from "@edreamsodigeo/frontend-api-client";

const SEND_SET_PASSWORD_EMAIL_MUTATION = gql`
  mutation SendSetPasswordEmail($request: SendSetPasswordEmailRequest!)
  @silent {
    sendSetPasswordEmail(request: $request) {
      acknowledged
    }
  }
`;

export default SEND_SET_PASSWORD_EMAIL_MUTATION;
